import React, { useEffect, useState } from "react"
import { Modal } from "react-bootstrap"
import PropTypes from "prop-types"
import { FormattedMessage } from "react-intl"

import { parseDate } from "../../../shared_components/utils"
import { API_STATUS } from "../../../shared_components/widgets/utils"
import PageLoadingPanel from "../../../shared_components/widgets/PageLoadingPanel"
import PageErrorPanel from "../../../shared_components/widgets/PageErrorPanel"
import { logToServer } from "../../../ErrorBoundary"
import { getObjectsList } from "../../../Loaders"
import { LocaleFormattedDate, CloseButton } from "../../internationalization/LocaleFormatted"

export default function ModalBackupView({ show, onHide, backup_id }) {
  const [status, setStatus] = useState(API_STATUS.LOADING)
  const [data, setData] = useState({})
  const onInitialLoad = () => {
    setStatus(API_STATUS.LOADING)

    getObjectsList(`/administration/api/database-backup/${backup_id}/`)
      .then((data) => {
        setStatus(API_STATUS.SUCCESS)
        setData(data)
      })
      .catch((error) => {
        console.error(error)
        logToServer(error)
        setStatus(API_STATUS.ERROR)
      })
  }

  useEffect(() => {
    onInitialLoad()
  }, [])

  return (
    <Modal show={show} onHide={onHide} backdrop={"static"} keyboard={true}>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className={"fa fa-bars"} />
          &nbsp;&nbsp;
          <FormattedMessage id={"administration.database-backup"} />{" "}
          {data && data.id ? '"' + data.id + '"' : ""}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ width: "700px" }}>
          {status === API_STATUS.LOADING ? (
            <PageLoadingPanel />
          ) : status === API_STATUS.ERROR ? (
            <PageErrorPanel attemptReload={onInitialLoad} />
          ) : (
            status === API_STATUS.SUCCESS && (
              <div>
                <div>
                  <label>
                    <FormattedMessage id="general.name" />:
                  </label>
                  &nbsp;
                  {data?.name || ""}
                </div>
                <div>
                  <label>
                    <FormattedMessage id="general.date" />:
                  </label>
                  &nbsp;
                  <LocaleFormattedDate date={data?.date} shouldParse={true} />
                </div>
                <div>
                  <label>
                    <FormattedMessage id={"general.log"} />:
                  </label>
                  &nbsp;
                  <textarea
                    style={{
                      width: "100%",
                      minHeight: "500px",
                      fontFamily: "Courier New",
                      fontSize: "14px",
                      resize: "none",
                      border: "solid 1px lightgray",
                      color: "var(--lanzalake-black)",
                    }}
                    readOnly={true}
                    value={data?.["content_log"] || ""}
                  />
                </div>
              </div>
            )
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <CloseButton onClose={onHide} />
      </Modal.Footer>
    </Modal>
  )
}

ModalBackupView.propTypes = {
  backup_id: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
}
